import React, { useEffect, useState, useContext } from 'react'
import { Button } from 'syngenta-react-components'
import { useForm, Controller } from 'react-hook-form'
import Select from '../../dpe-usco/components/Select/Select'
import clear from '../../assets/icons/clear.svg'
import TableStatus from '../subComponents/TableStatus/TableStatus'
import { LanguageContext } from '../../services/context'

const companyOptions = [
  { id: 'reseller', value: 'Reseller' },
  { id: 'grain-receiver', value: 'Grain receiver' },
  { id: '3PO', value: '3PO' }
]

const countryOptions = [
  { id: 'Canada', value: 'Canada' },
  { id: 'USA', value: 'USA' }
]


const states = [
  'AL','AK','AS','AZ','AR','CA','CO','CT','DE','DC','FM','FL','GA',
  'GU','HI','ID','IL','IN','IA','KS','KY','LA','ME','MH','MD','MA',
  'MI','MN','MS','MO','MT','NE','NV','NH','NJ','NM','NY','NC','ND',
  'MP','OH','OK','OR','PW','PA','PR','RI','SC','SD','TN','TX','UT',
  'VT','VI','VA','WA','WV','WI','WY'
]

const canadaStates = [
  'Alberta','British Columbia','Manitoba','New Brunswick','Newfoundland and Labrador',
  'Northwest Territories','Nova Scotia','Nunavut','Ontario','Prince Edward Island',
  'Quebec','Saskatchewan','Yukon'
]

const NewCompanyForm = ({ modalStatus, handleClose, handleSubmitNewCompanyForm, companyData, editMode }) => {
  const [ showIdFields , setShowIdFields ] = useState((companyData?.sap_id || companyData?.salesforce_id) && companyData?.company_type === 'reseller')
  const [showInventory, setShowInventory] = useState(companyData?.company_type === 'grain-receiver' || companyData?.company_type === '3PO')
  const { register, handleSubmit, reset, control, setValue, getValues, watch, errors } = useForm({
    defaultValues: {
      ...companyData,
      country: companyData ? companyData.country : '',
      company_type: companyData ? companyData.company_type : '',
      company: companyData ? companyData.company_name : '',
      address: companyData ? companyData.address1 : '',
      inventory: companyData ? companyData.inventory_code : '',
      supportedLang : companyData ? companyData.supported_languages : []
    }
  })
  
  const watchAllInputs = watch(['state'])
  const langData =  useContext(LanguageContext)
  const [selectedLang, setSelectedLang] =  useState(editMode?companyData.supported_languages:['en'])

  const onSubmit = formValues => {
    if(selectedLang.length > 0) {
      formValues.phone = formValues.phone.replace(/^(\+)|\D/g, '$1')
      formValues.supportedLang = selectedLang
      editMode ? handleSubmitNewCompanyForm(formValues, companyData.company_id) : handleSubmitNewCompanyForm(formValues)
      reset()
    }
  }
  
  useEffect(() => {
    if(showInventory){
      setValue('inventory', getValues('company').substring(0, 3).toUpperCase()+'1')
      if(editMode && companyData?.inventory_code !== 'N/A'){
        setValue('inventory', companyData?.inventory_code)
      }
    }
  }, [showInventory, editMode, setValue, getValues, companyData])

  const handleSelectCompanyType = option => {
    setValue('company_type', option.id)
    if(option.id === 'reseller'){
      setShowIdFields(true)
    }
    else {
      setShowIdFields(false)
    }
    if(option.id === 'grain-receiver' || option.id === '3PO'){
      setShowInventory(true)
    } else {
      setShowInventory(false)
    }
  }
  const handleSelectState = value => {
    setValue('state', value)
  }

  const handleCloseModal = arg => {
    handleClose(arg)
    reset()
  }

  let bottomButtons = (
    <>
      <Button text='Cancel' customClassName='mb8 mr8 pl16 pr16 pb10 pt10 fz16 fw600 bdrs-4' clickHandler={handleCloseModal} />
      <Button type='success' text={editMode ? 'Update company' : 'Create company'} clickHandler={handleSubmit(onSubmit)} customClassName=' mb8 mr8 pl16 pr16 pb10 pt10 fz16 fw600 bdrs-4' />
    </>
  )

  const setInventryFunc = e => {
    if(e.target.value.length > 2){
      setValue('inventory', e.target.value.substring(0, 3).toUpperCase()+'1')
    }
  }

  const [ countryOption , setCountryOption ] = useState(companyData?.country?companyData.country:'USA')
  const handleSelectCountryType = option => {
    if(option.id==='USA') 
      setValue([{ state:'AL' }])
    else
      setValue([{ state:'Alberta' }])
    setValue('country', option.id)
    setCountryOption(option.id)
  }

  const handleLangChange = e => {
    const checkData = e.target.value
    const values = [...selectedLang]
    if(e.target.checked && selectedLang.indexOf(checkData) === -1) {
      values.push(checkData)
    } 
    if(!e.target.checked && selectedLang.indexOf(checkData) !== -1) {
      values.splice(values.indexOf(checkData), 1)
    }
    setSelectedLang(values)
  }

  const statusInput = {
    display: 'inline-block',
    width: '13%',
    margin: 0
  }

  const dropDownStyle = {
    backgroundColor: 'white',
    marginTop: '5px',
    padding: '5px 0',
    fontWeight: '500',
    zIndex: 1,
    border: '2px solid #C4CDD5'
  }

  const statusContainer = {
    margin: '7px 0'
  }

  let content = (
    <form className='w100% tal' onSubmit={handleSubmit(onSubmit)}>

      <label className='fz13' htmlFor='company'>Country*</label>
      <div className='mb10'>
        <div className='fz15 w45%'>
          <Controller
            as={<Select defaultId={companyData ? companyData.country : null}/>}
            placeholder='Select country'
            handleSelection={handleSelectCountryType}
            options={countryOptions}
            control={control}
            name='country'
            id='country'
            rules={{ required: true }}
          />
          <div className='c-red tal fz12'>
            {errors.country && errors.country.type === 'required' && 'Please select country'}
          </div>
        </div>
      </div>

      <label className='fz13' htmlFor='company'>Company name*</label>
      <div className='mb10'>
        <input
          className='bd2-s-input mt4 fz15'
          type="text"
          id='company'
          name="company"
          ref={register({ required: true })} 
          onChange={setInventryFunc}  
        />
        <div className='c-red tal fz12'>
          {errors.company && errors.company.type === 'required' && 'Please provide company name'}
        </div>
      </div>
      <div className='df jcsb mb10'>
        <div className='w45%'>
          <label className='fz13'>Company type*</label>
          <div className='fz15' data-testid='companyType'>
            <Controller
              as={<Select defaultId={companyData ? companyData.company_type : null}/>}
              placeholder='Select company type'
              handleSelection={handleSelectCompanyType}
              options={companyOptions}
              control={control}
              name='company_type'
              id='company_type'
              rules={{ required: true }}
            />
            <div className='c-red tal fz12'>
              {errors.company_type && errors.company_type.type === 'required' && 'Please select company type'}
            </div>
          </div>
        </div>
        <div className='w45%'>
          <label htmlFor='phone' className='fz13'>Company phone*</label>
          <input 
            className='bd2-s-input fz15' 
            id='phone'
            type="text" 
            name="phone"
            ref={register({ required: true, pattern: /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/ })} />
          <div className='c-red tal fz12'>
            {errors.phone && errors.phone.type === 'required' && 'Please provide phone number'}
            {errors.phone && errors.phone.type === 'pattern' &&
                    'Please provide a valid phone number ex. 919-999-9999, limited to 10 digits'
            }
          </div>
        </div>     
      </div>

      {showInventory ? 
        <div className='mb10'>
          <label htmlFor='inventory' className='fz13'>Grain receiver inventory code*</label>
          <input
            id='inventory'
            className='bd2-s-input mt4 fz15' 
            type="text" 
            name="inventory"
            ref={register({ required: true, pattern: /^[0-9A-Z]{4}$/ })}
          />
          <div className='c-red tal fz12'>
            {errors.inventory && errors.inventory.type === 'required' && 'Please enter a Grain receiver inventory code'}
            {errors.inventory && errors.inventory.type === 'pattern' &&
            'Please provide a valid grain receiver inventory code (It should be in capital letter, the length should be 4 and only contain alphabetical letters or numbers)' }
          </div>
        </div> : null }
    
      {showIdFields ? 
        <div className='df jcsb  mb10'>
          <div className='w50% mr16'>
            <label htmlFor='SAPID' className='fz13'>SAP ID*</label>
            <input
              id='sap_id'
              data-testid='sap_id'
              className='bd2-s-input mt4  fz15'
              type="text"
              name="sap_id"
              ref={register({ required: true })} />
            <div className='c-red tal fz12'>
              {errors.sap_id && errors.sap_id.type === 'required' && 'Please provide name SAP ID'}
            </div>
          </div>
          <div className='w50%'>
            <label htmlFor='SFDCID' className='fz13'>SFDC ID*</label>
            <input
              id='salesforce_id'
              data-testid='salesforce_id'
              className='bd2-s-input mt4  fz15'
              type="text"
              name="salesforce_id"
              ref={register({ required: true })} />
            <div className='c-red tal fz12'>
              {errors.salesforce_id && errors.salesforce_id.type === 'required' && 'Please provide SFDC'}
            </div>
          </div>
        </div>
        : null}
      <div className='mb10'>
        <label htmlFor='address' className='fz13'>Company address*</label>
        <input
          id='address'
          className='bd2-s-input mt4 fz15' 
          type="text" 
          name="address"
          ref={register({ required: true })} />
        <div className='c-red tal fz12'>
          {errors.address && errors.address.type === 'required' && 'Please provide company address'}
        </div>
      </div>
      <label htmlFor='address2' className='fz13'>Company address line 2</label>
      <input
        id='address2'
        className='bd2-s-input mt4 mb10 fz15'
        type="text"
        name="address2"
        ref={register({ required: false })} />
      <div className='df jcsb  mb10'>
        <div className='w40%'>
          <label htmlFor='city' className='fz13'>City*</label>
          <input
            id='city'
            className='bd2-s-input mt4  fz15'
            type="text"
            name="city"
            ref={register({ required: true })} />
          <div className='c-red tal fz12'>
            {errors.city && errors.city.type === 'required' && 'Please provide name of the city'}
          </div>
        </div>
        <div className='ml4 w25%'>
          <label className='fz13'>State*</label>
          <div className='mt4 fz15'>      
            <Controller
              as={<Select defaultValue={watchAllInputs.state}/>}
              rules={{ required: true }}
              placeholder='State'
              handleSelection={handleSelectState}
              options={countryOption === 'USA' ? states:canadaStates}
              control={control}
              name='state'
              id='state'
            />
            <div className='c-red tal fz12'>
              {errors.state && errors.state.type === 'required' && 'Please select state'}
            </div>
          </div>
        </div>
        <div className='ml4 w25%'>
          <label htmlFor='zipcode' className='fz13'>Zip*</label>
          <input
            id='zipcode'
            className='bd2-s-input mt4 lh1.2 fz15'
            type="text"
            name="zipcode"
            ref={register({ required: true })} />
          <div className='c-red tal fz12'>
            {errors.zipcode && errors.zipcode.type === 'required' && 'Please provide zip code'}
          </div>
        </div>
      </div>

      <label className='fz13' htmlFor='company'>Supported language*</label>
      <div className='fz15 w40% mb10'>

        <div style={dropDownStyle}>
          {
            langData?.map((obj, index) => {
              return (
                <div style={statusContainer} key={index}>
                  <input
                    style={statusInput}
                    type="checkbox"
                    onChange={e=>handleLangChange(e)} 
                    name={`${obj.lang_value}`}
                    id={`${obj.lang_value}`}
                    value={`${obj.lang_value}`}
                    checked={selectedLang.indexOf(obj.lang_value) !== -1? true : false}
                  />
                  <label htmlFor={`${obj.lang_value}`}>
                    {obj.lang_name}
                  </label>
                </div>
              )
            })
          }
        </div>
        <div className='c-red tal fz12'>
          {selectedLang.length === 0 && 'Please select at lease one language'}
        </div>
      </div>

    </form>
  )

  switch(modalStatus){
    case 'LOADING':
      content = (
        <>
          <p className='w100% p0'>{`Company ${editMode? 'update' : 'creation'} in progress. Please wait.`}</p>
          <TableStatus status='LOADING'/>
        </>
      )
      bottomButtons = (
        <Button disabled type='success' text='Close' clickHandler={handleCloseModal} customClassName='mb8 mr8 pl16 pr16 pb10 pt10 fz16 fw600 bdrs-4'/>
      )
      break
    case 'SUCCESS':
      content = (
        <p className='w100% p0'>{`Successfully ${editMode ? 'updated' : 'created'} the company.`}</p>
      )
      bottomButtons = (
        <Button type='success' text={editMode ? 'Close' : 'Go to company'} clickHandler={() => handleCloseModal('SUCCESS')} customClassName='mb8 mr8 pl16 pr16 pb10 pt10 fz16 fw600 bdrs-4'/>
      )
      break
    case 'FAILED':
      content = (
        <p className='w100% p0'>Something went wrong. Please contact your admin.</p>
      )
      bottomButtons = (
        <Button type='success' text='Close' clickHandler={handleCloseModal} customClassName='mb8 mr8 pl16 pr16 pb10 pt10 fz16 fw600 bdrs-4'/>
      )
      break
    default:
      break
  }

  return (
    <div data-testid='newCompanyModal' className='w100% h100% bgc-white bd2-s-input bxshmodal bdrs-4'>
      <div className='df jcsb'>
        <p className='fz16 ml16 fw600'>{editMode ? 'Update company' : 'Create new company'}</p>
        <button className='bdnone m0 bgc-t' onClick={handleCloseModal}>
          <img src={clear} alt='cancel button' />
        </button>
      </div>
      <hr className='mt0 mb16 bdnone bt1-s-lightgray' />
      <div className='pl16 pr16 df fxdrr fxww'>
        {content}
      </div>
      <hr className='mt20 mb16 bdnone bt1-s-lightgray' />
      <div className='df jcfe' data-testid='newCompanyButtons'>
        {bottomButtons}
      </div>
    </div>
  )
}

export default NewCompanyForm